const InitFooter = () => {
  const body = document.body;
  const footerBtnArrow = document.querySelectorAll(
    '.primary-menu-footer .btn-arrow, .primary-menu .btn-arrow'
  );
  Array.from(footerBtnArrow).forEach((el) => {
    el.addEventListener('click', (e) => {
      const parentMenu = e.target.parentNode;
      const subMenuHeight = parentMenu.querySelector('.sub-menu');
      parentMenu.style.setProperty(
        '--h',
        parentMenu.offsetHeight + subMenuHeight.offsetHeight + 'px'
      );
      parentMenu.classList.toggle('is-active');
    });
  });
};
export default InitFooter;
